import compose from 'lodash.flowright';
import { graphql, withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import WebGalleryFavoritePhotos from './WebGalleryFavoritePhotos';
import { PhotoPrintSizes } from '../../graphql/queries/print-sizes';
import { openModal } from '../../../../actions/modal-actions';
import {
  AlbumAccountFavoritePhotos,
  AlbumFolderAccountFavoritePhotos,
} from '../../graphql/queries/favorites';
import withFavoritePhotosMutations from '../../hoc/withFavoritePhotosMutations';
import { AlbumFolderForWebGalleries } from '../../graphql/queries/album-folder';
import { AccountPurchases } from '../../graphql/queries/account';

const withFolderData = graphql(AlbumFolderForWebGalleries, {
  options: ({ match }) => ({
    variables: {
      id: match.params.folderId,
    },
  }),
  props: ({ data: { albumFolder, loading } }) => ({
    folder: albumFolder,
    loadingFolder: loading,
    albumCustomPrint: (albumFolder?.album_custom_prints?.records ?? [])[0],
  }),
  skip: ({ match }) => !match.params.folderId,
});

const withAlbumFolderAccountFavoritePhotos = graphql(
  AlbumFolderAccountFavoritePhotos,
  {
    options: ({ match }) => ({
      variables: {
        id: match.params.folderId,
      },
      fetchPolicy: 'cache-and-network',
    }),
    props: ({ data: { albumFolder, loading } }) => ({
      loading,
      favoritePhotos: albumFolder?.account_favorite_photos,
    }),
    skip: ({ match }) => !match.params.folderId,
  },
);

// For individual albums support (i.e. not part of a gallery)
const withAlbumAccountFavoritePhotos = graphql(AlbumAccountFavoritePhotos, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data: { album, loading } }) => ({
    loading,
    favoritePhotos: album?.account_favorite_photos,
    album,
  }),
  skip: ({ match }) => !match.params.albumId,
});

const withAccountPurchases = graphql(AccountPurchases, {
  props: ({ data: { me } }) => ({
    accountAlbumMemberships: me,
  }),
  skip: ({ authenticated }) => !authenticated,
});

const withPrintSizes = graphql(PhotoPrintSizes, {
  props: ({ data: { loading, photoPrintSizes } }) => ({
    loadingPrintSizes: loading,
    printSizes: photoPrintSizes && photoPrintSizes.records,
  }),
});

const mapStateToProps = ({ webGalleryCart, auth }) => ({
  selectedDownloads: webGalleryCart.selectedDownloads,
  selectedPrints: webGalleryCart.selectedPrints,
  purchasedDownloads: webGalleryCart.purchasedDownloads,
  authenticated: auth.authenticated,
});

const mapDispatchToProps = dispatch => ({
  openModal: name => dispatch(openModal(name)),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withPrintSizes,
  withFolderData,
  withAlbumFolderAccountFavoritePhotos,
  withAlbumAccountFavoritePhotos,
  withFavoritePhotosMutations,
  withAccountPurchases,
  withApollo,
)(WebGalleryFavoritePhotos);
